import type { Ref } from 'vue'
import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { QueryParams } from '@/const/MessagesListQueryFilters'
import { appendToParams } from '@/services/Url'

type Input = {
  route: RouteLocationNormalizedLoaded
  serverOptions: Ref
  detailed: boolean
  baseFilter: Record<string, string>
}

export const makeRequestParams = ({ route, serverOptions, detailed, baseFilter }: Input) => {
  const params = new URLSearchParams({
    ...baseFilter,
    limit: String(serverOptions.value.rowsPerPage || 50),
    page: String(serverOptions.value.page || 1),
  })

  /**
   * If not detailed view is requested, we are not applying any extra filters to not make the filters from parent
   * table get in the way of messages table (non-detailed messages table is rendered in shipments feed which uses
   * the same filtering concept)
   */
  if (!detailed) {
    return params
  }

  if (route?.query.statuses) {
    const appender = appendToParams(params, QueryParams.STATUS)
    String(route.query.statuses).split(',').forEach(appender)
  }

  if (route?.query.carriers) {
    const appender = appendToParams(params, QueryParams.CARRIER_HANDLE)
    String(route.query.carriers).split(',').forEach(appender)
  }

  if (route?.query.shipmentNumber) {
    const appender = appendToParams(params, QueryParams.SHIPMENT_NUMBER)
    String(route.query.shipmentNumber).split(',').forEach(appender)
  }

  if (route?.query.country) {
    const appender = appendToParams(params, QueryParams.COUNTRY)
    String(route.query.country).split(',').forEach(appender)
  }

  if (route?.query.assignment) {
    const appender = appendToParams(params, QueryParams.ASSIGNMENT)
    String(route.query.assignment).split(',').forEach(appender)
  }

  if (route?.query.dateFrom) {
    params.append(QueryParams.DATE_FROM, String(route.query.dateFrom))
  }

  if (route?.query.dateTo) {
    params.append(QueryParams.DATE_TO, String(route.query.dateTo))
  }

  return params
}
